import AssetLogo from "./ASK-IT-ALL.svg";
import IconBooking from "./icons/Bookings.svg";
import IconHistory from "./icons/History.svg";
import IconPayment from "./icons/Payment.svg";
import IconProfile from "./icons/Profile.svg";
import IconReport from "./icons/Report.svg";
import IconSettings from "./icons/Settings.svg";
import IconLogout from "./icons/Logout.svg";
import IconFilter from './icons/Filter.svg';
import MangCoding from './icons/mangacoding.svg';
import GooglePlay from './icons/Googleplay.svg';
import AppStore from './icons/AppleStore.svg';
import RiidLogo from './icons/riidllogo1 1.svg';
import IconCall from './icons/Call.svg';
import FasterCaptialLogo from './icons/faster capital 1.svg';
import MockUserImage from '../svg/icons/MockUserImage.svg';
import CashbackBgImage from '../svg/icons/coins.png';

export const LOGO = AssetLogo;

// ICONS
export const ICON_BOOKING = IconBooking;
export const ICON_HISTORY = IconHistory;
export const ICON_PAYMENT = IconPayment;
export const ICON_PROFILE = IconProfile;
export const ICON_REPORT = IconReport;
export const ICON_SETTINGS = IconSettings;
export const ICON_LOGOUT = IconLogout;
export const ICON_FILTER = IconFilter;
export const ICON_MANGCODING = MangCoding;
export const BUTTON_GOOGLEPLAY = GooglePlay;
export const BUTTON_APPSTORE = AppStore;
export const LOGO_RIID = RiidLogo;
export const LOGO_FasterCaptial = FasterCaptialLogo;
export const ICON_CALL = IconCall;
export const MOCK_USER_IMAGE = MockUserImage;
export const CASHBACK_IMAGE = CashbackBgImage;